// extracted by mini-css-extract-plugin
export default {"loginPage":"style_loginPage__SAZ-7"};